import MuiStack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const Stack = styled(MuiStack)`
  height: 100%;
`;
